import { render, staticRenderFns } from "./SotecDashboard.vue?vue&type=template&id=929f636a&scoped=true&"
import script from "./SotecDashboard.vue?vue&type=script&lang=js&"
export * from "./SotecDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SotecDashboard.vue?vue&type=style&index=0&id=929f636a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929f636a",
  null
  
)

export default component.exports